import { BaseButton } from '@/components/common/base-button';
import { LocationMarkerIcon } from '@/components/icons';
import { useAccessibilityTTS } from '@/hooks';
import { useConfigStore } from '@/stores';
import { formatDistance } from '@/utils/route-simulation';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './styles.module.scss';

type Props = {
    name: string;
    selected?: boolean;
    onSelect: () => void;
    hideSelectedStyles?: boolean;
    dataModalRegion?: boolean;
    selectedPoiId?: string;
    showDistance?: boolean;
    distance?: number;
};
export const NearbyPoiItem = ({ name, selected = false, onSelect, hideSelectedStyles = false, dataModalRegion = false, showDistance, distance }: Props) => {
    const { t } = useTranslation();
    const { speak } = useAccessibilityTTS();
    const language = useConfigStore((state) => state.config?.ui?.language);
    const ariaLabelButton = `${t('common.tts.location')}, ${t('floor_guide.text_to_speech.nearby_poi', { poiName: name })}`;

    const getDistanceText = (distance?: number) => {
        const distanceText = formatDistance(distance);

        const distanceTextTranslated = t('floor_guide.text_to_speech.distance', { distance: distanceText });
        const distanceTextTranslatedPlural = t('floor_guide.text_to_speech.distance_plural', { distance: distanceText });

        if (language === 'en') {
            return distanceText === 1 ? distanceTextTranslated : distanceTextTranslatedPlural;
        }
        return distanceTextTranslated;
    };

    const generateAriaRadioLabel = (selected: boolean) => {
        return `${selected ? t('common.button.tts.status_selected') : t('common.button.tts.status_not_selected')} ${getDistanceText(distance)}, ${t('floor_guide.text_to_speech.nearby_poi', { poiName: name })}, ${t('common.button.tts.radio_button')}`;
    };
    return (
        <BaseButton
            data-tts-scope="nearby-poi-item"
            className={clsx(styles['poi-item'], selected && !hideSelectedStyles && styles['poi-item--selected'])}
            data-modal-region={dataModalRegion}
            onFocus={() => {
                if (hideSelectedStyles) {
                    speak(ariaLabelButton);
                } else {
                    speak(generateAriaRadioLabel(selected));
                }
            }}
            onClick={() => {
                if (hideSelectedStyles) {
                    speak(ariaLabelButton);
                } else {
                    speak(generateAriaRadioLabel(true));
                }
                onSelect();
            }}
        >
            <span className="text-text-main01">
                <LocationMarkerIcon width={24} height={24} />
            </span>
            <span className={clsx(styles['poi-item__name'], selected && !hideSelectedStyles && styles['poi-item__name--selected'])}>
                {showDistance && <span className={styles['poi-item__name__distance']}>{formatDistance(distance)}m, </span>}
                <span className={styles['poi-item__name__title']}>{t('floor_guide.title.nearby', { poiName: name })}</span>
            </span>
        </BaseButton>
    );
};
